(() => {
  const modal = document.querySelector('[data-mm-order-modal]');
  if (!modal) return;

  const q = (sel, root = modal) => root.querySelector(sel);
  const qa = (sel, root = modal) => Array.from(root.querySelectorAll(sel));

  const linesEl = q('[data-mm-lines]');
  const counterEl = q('[data-mm-counter]');
  const confirmBtn = q('[data-mm-confirm]');
  const confirmLabel = q('[data-mm-confirm-label]');
  const statusEl = q('[data-mm-status]');
  const errorEl = q('[data-mm-error]');
  const resetBtn = q('[data-mm-reset]');

  const feeCents = Number(modal.dataset.feeCents) || 0;
  const freeCents = Number(modal.dataset.freeCents) || 0;
  const feeLabel = modal.dataset.feeLabel || '25 DH';

  const COPY = {
    fr: {
      pack: "Choisissez l'offre qui vous convient.",
      diffuser: 'Choisissez le parfum de votre diffuseur.',
      refills: 'Choisissez les parfums de vos recharges — vous pouvez les mélanger.',
      reassure: 'Paiement à la livraison · Livraison partout au Maroc',
      counter: (n, t) => `${n} sur ${t} recharge${t > 1 ? 's' : ''} sélectionnée${n > 1 ? 's' : ''}`,
      needDiffuser: 'Choisissez un diffuseur pour continuer.',
      needRefills: (n) => `Il reste ${n} recharge${n > 1 ? 's' : ''} à choisir.`,
      free: 'Offerte',
      confirm: 'Continuer vers la commande',
    },
    ar: {
      pack: 'اختر العرض المناسب لك',
      diffuser: 'اختر رائحة معطّر السيارة',
      refills: 'اختر روائح عبوات إعادة التعبئة — يمكنك المزج بينها',
      reassure: 'الدفع عند الاستلام · التوصيل إلى جميع أنحاء المغرب',
      counter: (n, t) => `${n} من ${t}`,
      needDiffuser: 'أكمل العدد المطلوب للمتابعة',
      needRefills: () => 'أكمل العدد المطلوب للمتابعة',
      free: 'مجاني',
      confirm: 'المتابعة إلى الطلب',
    },
  };

  let lang = 'fr';
  let busy = false;
  let lastOpener = null;

  const money = (cents) => {
    const fmt = (window.Shopify && window.Shopify.moneyFormat) || '{{amount_no_decimals}} DH';
    return fmt
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/, Math.round(cents / 100))
      .replace(/\{\{\s*amount\s*\}\}/, (cents / 100).toFixed(2));
  };

  const packInput = () => q('[data-mm-pack]:checked');
  const diffuserInput = () => q('[data-mm-diffuser]:checked');
  const refillRows = () => qa('[data-mm-refill]');
  const qtyOf = (row) => Number(q('[data-mm-qty]', row).textContent) || 0;
  const setQty = (row, n) => {
    q('[data-mm-qty]', row).textContent = String(n);
    row.classList.toggle('is-active', n > 0);
  };
  const totalRefills = () => refillRows().reduce((s, r) => s + qtyOf(r), 0);
  const wanted = () => {
    const p = packInput();
    return p ? Number(p.dataset.refills) || 0 : 0;
  };

  // --- i18n -----------------------------------------------------------------
  function applyLang() {
    const c = COPY[lang];
    qa('[data-mm-i18n]').forEach((el) => {
      const key = el.dataset.mmI18n;
      if (!c[key]) return;
      el.textContent = c[key];
      el.setAttribute('lang', lang === 'ar' ? 'ar' : 'fr');
      if (lang === 'ar') el.setAttribute('dir', 'rtl');
      else el.removeAttribute('dir');
    });
    qa('[data-mm-lang]').forEach((b) => {
      const on = b.dataset.mmLang === lang;
      b.classList.toggle('is-active', on);
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
    update();
  }

  qa('[data-mm-lang]').forEach((b) =>
    b.addEventListener('click', () => {
      lang = b.dataset.mmLang === 'ar' ? 'ar' : 'fr';
      applyLang();
    })
  );

  // --- summary --------------------------------------------------------------
  function lineRow(term, detail, pending) {
    const wrap = document.createElement('div');
    wrap.className = 'mm-om__line' + (pending ? ' mm-om__line--pending' : '');
    const dt = document.createElement('dt');
    dt.textContent = term;
    const dd = document.createElement('dd');
    dd.textContent = detail;
    wrap.appendChild(dt);
    wrap.appendChild(dd);
    return wrap;
  }

  // "1 × Onyx · 1 × Apex · 1 × Khayali" — the same string the order carries.
  function refillSummary() {
    return refillRows()
      .filter((r) => qtyOf(r) > 0)
      .map((r) => `${qtyOf(r)} × ${r.dataset.short}`)
      .join(' · ');
  }

  function update() {
    const c = COPY[lang];
    const p = packInput();
    const d = diffuserInput();
    const want = wanted();
    const have = totalRefills();

    refillRows().forEach((row) => {
      q('[data-mm-inc]', row).disabled = have >= want;
      q('[data-mm-dec]', row).disabled = qtyOf(row) <= 0;
    });

    counterEl.textContent = c.counter(have, want);
    counterEl.classList.toggle('is-complete', want > 0 && have === want);

    linesEl.innerHTML = '';
    linesEl.appendChild(
      d ? lineRow(`Diffuseur : ${d.dataset.title}`, 'Inclus', false) : lineRow('Diffuseur', '—', true)
    );
    const refills = refillSummary();
    linesEl.appendChild(
      refills ? lineRow(`Recharges : ${refills}`, 'Inclus', false) : lineRow('Recharges', '—', true)
    );

    const price = p ? Number(p.dataset.price) : 0;
    const compare = p ? Number(p.dataset.compare) : 0;
    const saving = compare > price ? compare - price : 0;
    const free = price > 0 && price >= freeCents;
    const delivery = free ? 0 : feeCents;
    const total = price + delivery;

    q('[data-mm-offer]').textContent = p ? money(price) : '—';
    const stdRow = q('[data-mm-standard-row]');
    stdRow.hidden = saving <= 0;
    if (saving > 0) q('[data-mm-standard]').textContent = money(compare);
    const savRow = q('[data-mm-saving-row]');
    savRow.hidden = saving <= 0;
    if (saving > 0) q('[data-mm-saving]').textContent = money(saving);
    q('[data-mm-delivery]').textContent = p ? (free ? c.free : money(delivery)) : '—';
    q('[data-mm-total]').textContent = p ? money(total) : '—';

    // Always offered. Hiding it until something was chosen meant a customer
    // arriving with a cart already full had no visible way to empty it.
    if (resetBtn) resetBtn.hidden = false;

    const complete = Boolean(p) && Boolean(d) && want > 0 && have === want;
    confirmBtn.disabled = !complete || busy;
    confirmLabel.textContent = complete ? `${c.confirm} — ${money(total)}` : c.confirm;

    if (!statusEl.dataset.locked) {
      statusEl.textContent = complete ? '' : !d ? c.needDiffuser : have < want ? c.needRefills(want - have) : '';
    }
  }

  // --- interactions ---------------------------------------------------------
  // Changing the pack changes how many refills are allowed. Trim from the end
  // rather than clearing, so a customer who moves 3 -> 2 keeps their choices.
  function clampRefills() {
    const want = wanted();
    let have = totalRefills();
    if (have <= want) return;
    const rows = refillRows().slice().reverse();
    for (const row of rows) {
      while (have > want && qtyOf(row) > 0) {
        setQty(row, qtyOf(row) - 1);
        have -= 1;
      }
      if (have <= want) break;
    }
  }

  qa('[data-mm-pack]').forEach((i) =>
    i.addEventListener('change', () => {
      delete statusEl.dataset.locked;
      clampRefills();
      update();
    })
  );
  qa('[data-mm-diffuser]').forEach((i) =>
    i.addEventListener('change', () => {
      delete statusEl.dataset.locked;
      update();
    })
  );
  refillRows().forEach((row) => {
    q('[data-mm-inc]', row).addEventListener('click', () => {
      if (totalRefills() >= wanted()) return;
      delete statusEl.dataset.locked;
      setQty(row, qtyOf(row) + 1);
      update();
    });
    q('[data-mm-dec]', row).addEventListener('click', () => {
      if (qtyOf(row) <= 0) return;
      delete statusEl.dataset.locked;
      setQty(row, qtyOf(row) - 1);
      update();
    });
  });

  // Clears the composition back to an empty Pack 3 and empties any pack line
  // already sitting in the cart, so "start again" really is a clean slate.
  function reset() {
    qa('[data-mm-diffuser]').forEach((i) => {
      i.checked = false;
    });
    refillRows().forEach((r) => setQty(r, 0));
    const best = qa('[data-mm-pack]:not([disabled])').pop();
    if (best) best.checked = true;
    delete statusEl.dataset.locked;
    statusEl.textContent = '';
    errorEl.hidden = true;

    // Empty the whole cart, not just the pack lines. "Start again" has to mean
    // the basket is genuinely empty, otherwise a stray item added elsewhere
    // survives and shows up on the order the customer thought they had reset.
    fetch(`${window.routes.cart_url}/clear.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
    })
      .then(() => {
        statusEl.textContent = 'Panier vidé. Composez votre offre.';
        const badge = document.querySelector('[data-mm-cart-count]');
        if (badge) {
          badge.textContent = '';
          badge.hidden = true;
        }
      })
      .catch(() => {
        errorEl.textContent = 'Impossible de vider le panier. Réessayez.';
        errorEl.hidden = false;
      });

    update();
    const first = q('[data-mm-diffuser]');
    if (first) first.focus({ preventScroll: true });
  }

  if (resetBtn) resetBtn.addEventListener('click', reset);

  // --- open / close ---------------------------------------------------------
  function selectPack(key) {
    if (!key) return false;
    const match = qa('[data-mm-pack]').find(
      (i) => i.dataset.handle === key || i.value === String(key)
    );
    if (match && !match.disabled) {
      match.checked = true;
      return true;
    }
    return false;
  }

  function selectDiffuser(key) {
    if (!key) return false;
    const k = String(key).toLowerCase();
    const match = qa('[data-mm-diffuser]').find(
      (i) =>
        i.value === String(key) ||
        (i.dataset.short || '').toLowerCase() === k ||
        (i.dataset.title || '').toLowerCase() === k
    );
    if (match && !match.disabled) {
      match.checked = true;
      return true;
    }
    return false;
  }

  // "onyx:1,khayali:2" — an explicit distribution from a finished composer.
  function applyRefills(spec) {
    if (!spec) return false;
    const map = {};
    String(spec)
      .split(',')
      .forEach((pair) => {
        const [name, n] = pair.split(':');
        if (!name) return;
        map[name.trim().toLowerCase()] = Number(n) || 0;
      });
    if (!Object.keys(map).length) return false;
    refillRows().forEach((row) => setQty(row, map[(row.dataset.short || '').toLowerCase()] || 0));
    return true;
  }

  // `source` is either the element that was clicked (its data-* attributes
  // carry the selection) or a plain object from another component.
  function open(source) {
    const isEl = source instanceof HTMLElement;
    lastOpener = isEl ? source : null;
    errorEl.hidden = true;
    delete statusEl.dataset.locked;
    statusEl.textContent = '';

    const d = isEl ? source.dataset : source || {};
    // Default to the recommended pack only when the CTA names none.
    if (!selectPack(d.pack) && !packInput()) {
      const best = qa('[data-mm-pack]:not([disabled])').pop();
      if (best) best.checked = true;
    }
    // A scent is only preselected when the CTA carries one. Never fall back to
    // Onyx: silently choosing a fragrance the customer did not pick is how the
    // wrong bottle ends up in the box.
    selectDiffuser(d.diffuser);
    clampRefills();
    if (!applyRefills(d.refills)) clampRefills();

    update();
    if (!modal.open) modal.showModal();
    const focusTarget = q('.mm-om__close');
    if (focusTarget) focusTarget.focus({ preventScroll: true });
  }

  function close() {
    if (modal.open) modal.close();
  }

  modal.addEventListener('close', () => {
    if (lastOpener && document.contains(lastOpener)) lastOpener.focus({ preventScroll: true });
  });

  // Clicking the backdrop: the dialog element itself only covers the backdrop
  // area, the shell sits inside it.
  modal.addEventListener('click', (event) => {
    if (event.target === modal) close();
  });
  qa('[data-mm-om-close]').forEach((b) => b.addEventListener('click', close));

  document.addEventListener('click', (event) => {
    const opener = event.target.closest('[data-mm-order-open]');
    if (!opener) return;
    event.preventDefault();
    open(opener);
  });

  window.MMOrderModal = { open, close };

  // --- confirm --------------------------------------------------------------
  function confirm() {
    if (busy || confirmBtn.disabled) return;
    const p = packInput();
    const d = diffuserInput();
    if (!p || !d) return;

    busy = true;
    confirmBtn.disabled = true;
    errorEl.hidden = true;
    statusEl.dataset.locked = '1';
    statusEl.textContent = 'Préparation de votre panier…';

    // The composition travels as two readable properties. Whoever packs the
    // box reads these lines verbatim, so they say what is in it rather than
    // carrying an opaque option code.
    const properties = {
      Diffuseur: d.dataset.title,
      Recharges: refillSummary(),
    };

    // Re-opening the modal must never stack a second pack. Zero out every pack
    // variant first, then add the chosen one; non-pack lines are untouched.
    const clear = {};
    qa('[data-mm-pack]').forEach((i) => {
      clear[i.value] = 0;
    });

    fetch(`${window.routes.cart_update_url}.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ updates: clear }),
    })
      .then(() =>
        fetch(`${window.routes.cart_add_url}.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id: Number(p.value), quantity: 1, properties }] }),
        })
      )
      .then((r) => r.json().then((data) => ({ ok: r.ok, data })))
      .then(({ ok, data }) => {
        if (!ok) {
          errorEl.textContent = data.description || data.message || 'Commande impossible pour le moment.';
          errorEl.hidden = false;
          statusEl.textContent = '';
          busy = false;
          update();
          return;
        }
        // Prefer opening the COD form in place. When the app is scoped to the
        // cart page its trigger is not bound anywhere else, so the fallback
        // goes to /cart — where the form does exist and where Shopify's own
        // button is still there if the app is down. Never to /checkout: that
        // is the eight-field form this whole flow exists to avoid.
        handOffToCod().catch(() => {
          window.location.href = `${window.routes.cart_url}?cod=1`;
        });
      })
      .catch(() => {
        errorEl.textContent = 'Commande impossible pour le moment. Réessayez dans un instant.';
        errorEl.hidden = false;
        statusEl.textContent = '';
        busy = false;
        update();
      });
  }

  // Opening the COD form in place is deliberately not attempted any more.
  // EasySell's documented `es-popup-button-overwrite` hook does not bind while
  // the app is scoped to the cart page, and when it is scoped to the whole
  // store it treats our element as a PRODUCT buy button: clicking it added an
  // 85 DH diffuser to the cart behind the customer's back, so a 199 DH pack
  // would have been billed at 284 DH. Going to /cart and letting the app's own
  // cart button open the form is slower by one page load and correct.
  function handOffToCod() {
    return Promise.reject(new Error('no safe in-place trigger'));
  }

  confirmBtn.addEventListener('click', confirm);

  // Arriving at /cart from the modal: open the COD form straight away rather
  // than making the customer find a second button for a decision they already
  // made. Uses EasySell's own documented hook, on the page where it is bound.
  // Retries because the app boots on its own schedule, and gives up quietly —
  // the cart page is perfectly usable on its own.
  function autoOpenOnCart() {
    const params = new URLSearchParams(window.location.search);
    if (params.get('cod') !== '1') return;

    // Drop the flag so a refresh or a back-navigation does not re-open it.
    params.delete('cod');
    const clean = window.location.pathname + (params.toString() ? `?${params}` : '');
    window.history.replaceState({}, '', clean);

    // Clicks the COD app's own rendered button — the same element and the same
    // handler the customer would use, identified by the id the app gives it.
    // The documented `es-popup-button-overwrite` hook was tried first and does
    // not bind to an element of ours on any page, so this is the only route
    // left. It is deliberately forgiving: if the button never appears we stop
    // and leave the cart page as it is, which is fully usable on its own.
    const started = Date.now();
    const attempt = () => {
      const modalEl = document.getElementById('easysell-modal');
      if (modalEl && getComputedStyle(modalEl).display !== 'none') return;
      if (Date.now() - started > 8000) return;
      // Must be the cart button, never a product one. The app gives every
      // injected button the same id, so getElementById returns whichever comes
      // first in the document — a product button when the app is scoped to the
      // whole store, which adds that product to the cart on click.
      const btn = document.querySelector('.es-popup-button-cart');
      if (btn && btn.offsetParent !== null) btn.click();
      window.setTimeout(attempt, 400);
    };
    window.setTimeout(attempt, 700);
  }

  autoOpenOnCart();
  applyLang();
})();
